// Foto che il browser non mostra: RAW delle fotocamere (Canon, Nikon, Sony...), HEIC degli
// iPhone (Chrome non li apre), TIFF. Il BE ne crea una copia JPG/WebP che si usa per
// miniatura e anteprima; finché la copia non c'è, la UI propone di scaricare il file.

import { urlPathExt } from './videoPlayback';

export const BROWSER_IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp'];
export const CONVERTIBLE_IMAGE_EXTS = ['cr2', 'cr3', 'nef', 'arw', 'dng', 'raf', 'orf', 'rw2', 'heic', 'heif', 'tif', 'tiff'];

export const isConvertibleImageExt = (ext?: string | null): boolean =>
    CONVERTIBLE_IMAGE_EXTS.includes((ext || '').toLowerCase());

/** true se l'URL punta a un'immagine che il browser mostra (es. la copia JPG di un .CR2). */
export const isBrowserImageUrl = (url?: string | null): boolean =>
    BROWSER_IMAGE_EXTS.includes(urlPathExt(url));

/** Foto da mostrare come <img>: formato del browser, oppure formato da convertire con la copia già pronta. */
export const isPreviewableImage = (ext?: string | null, url?: string | null): boolean => {
    const e = (ext || '').toLowerCase();
    return BROWSER_IMAGE_EXTS.includes(e) || (isConvertibleImageExt(e) && isBrowserImageUrl(url));
};

/**
 * true se la copia mostrata ha un formato diverso dal file caricato (es. .CR2 → .jpg,
 * .MTS → .mp4): in quel caso serve anche "Scarica originale".
 */
export const copiaInAltroFormato = (nomeFile?: string | null, urlCopia?: string | null): boolean => {
    const nome = nomeFile || '';
    const dot = nome.lastIndexOf('.');
    if (dot < 0) return false;
    const orig = nome.slice(dot + 1).toLowerCase();
    const copia = urlPathExt(urlCopia);
    if (!orig || !copia || orig === copia) return false;
    const jpeg = ['jpg', 'jpeg'];
    return !(jpeg.includes(orig) && jpeg.includes(copia));
};
